var $ = require('jquery');

$(document).ready(function() {
    initCover();
})
function initCover() {
    $('.page-section--main > .wp-block-cover').each(function() {
        var prev = $(this).prev();

        if(prev.length == 0) {
            $(this).addClass('-banner');
        }

        if ( $(this).next().children().hasClass('slider') ) {
            $(this).addClass('-overlap');
        }
    })
}